import React, { useImperativeHandle, useRef } from "react";
import { Grid } from "@mui/material";
import { AutocompleteField } from "@curves/ui-base";
import usePeopleApi from "@apis/usePeopleApi";
import { refIsRequiredError, getErrorModuleStatus } from "@util/utils";
import { PEOPLE_TYPE } from "@icoach/constants/dataEnums";

/**
 * 會員欄位組件
 * 用於選擇會員（姓名/手機號碼/會員編號）
 */
const MemberField = React.forwardRef((props, ref) => {
	const { defaultValue, readOnly, errorModule = {} } = props;
	const { people: memberOptions = [] } = usePeopleApi(PEOPLE_TYPE.ALLMEMBER);
	const memberRef = useRef();

	useImperativeHandle(
		ref,
		() => ({
			getResult: () => {
				return {
					receiverID: memberRef.current?.getResult()?.id,
				};
			},
			isError: () => refIsRequiredError(memberRef),
		}),
		// eslint-disable-next-line
		[],
	);

	return (
		<Grid xs={5} item>
			<AutocompleteField
				key={memberOptions}
				className="flex-auto"
				defaultValue={defaultValue}
				label="姓名/手機號碼/會員編號(擇一即可)"
				ref={memberRef}
				options={memberOptions}
				optionKeys={["name", "nickName", "mobile", "no"]}
				optionMaskKeys={["maskName", "nickName", "maskMobile", "no"]}
				primaryKey="id"
				InputProps={{
					disabled: readOnly,
				}}
				fullWidth
				required
				{...getErrorModuleStatus(errorModule, "receiverID")}
			/>
		</Grid>
	);
});

MemberField.displayName = "MemberField";

export default MemberField;

